export default __webpack_public_path__ + "static/media/Silver clouds2.8a35ca08.jpg";